import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo_small from "../NavBar/Asset/New_Assert/ESO_ICON.png";
export default function Pricingpage() {
  const [isYearly, setIsYearly] = useState(false);
  const [userCountry, setUserCountry] = useState("India"); // default
  const navigate = useNavigate();

  // Detect country using browser locale
  useEffect(() => {
    const locale = navigator.language || navigator.userLanguage;
    if (locale.includes("IN")) {
      setUserCountry("India");
    } else {
      setUserCountry("Other");
    }
  }, []);

  const isIndianUser = userCountry !== "India";


  const usdPricing  = {
    monthly: [
      { title: "Free", price: 0, old: 0, desc: "Free Trial Plan" },
      { title: "Basic", price: 4349, old: 6349, desc: "Recommended for bloggers & startups" },
      { title: "Pro", price: 6124, old: 8124, desc: "Most popular for freelancers & businesses" },
      { title: "Enterprise", price: 10562, old: 12562, desc: "Best for agencies & enterprises" }
    ],
    yearly: [
      { title: "Free", price: 0, old: 0, desc: "Free Trial Plan" },
      { title: "Basic", price: 41731, old: 43717, desc: "Discount yearly plan" },
      { title: "Pro", price: 55227, old: 57759, desc: "Discount yearly plan" },
      { title: "Enterprise", price: 103397, old: 121397, desc: "Discount yearly plan" }
    ]
  };

  // USA / Global (STATIC USD PRICING)
  const  indiaPricing= {
    monthly: [
      { title: "Free", price: 0, old: 0, desc: "Free Trial Plan" },
      { title: "Basic", price: 49, old: 69, desc: "Recommended for bloggers & startups" },
      { title: "Pro", price: 69, old: 99, desc: "Most popular for freelancers & businesses" },
      { title: "Enterprise", price: 119, old: 149, desc: "Best for agencies & enterprises" }
    ],
    yearly: [
      { title: "Free", price: 0, old: 0, desc: "Free Trial Plan" },
      { title: "Basic", price: 470, old: 699, desc: "Discount yearly plan" },
      { title: "Pro", price: 662, old: 999, desc: "Discount yearly plan" },
      { title: "Enterprise", price: 1142, old: 1999, desc: "Discount yearly plan" }
    ]
  };

  // SELECT WHICH PRICING TO USE
  const pricingData = isIndianUser ?  usdPricing : indiaPricing;
  const plans = isYearly ? pricingData.yearly : pricingData.monthly;

  return (
    <>
      {/* INLINE CSS */}
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: "Work Sans", sans-serif; background: #f5f5f5; }

        .pricing-header {
          width: 100%;
          padding: 18px 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #ffffff;
          position: sticky;
          top: 0;
          z-index: 100;
          border-bottom: 1px solid #eee;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }

  
  .small-logos{
       height:40px;
         cursor: pointer;
         }
        .login-btn {
          background: transparent;
          border: 2px solid #ff6600;
          padding: 8px 20px;
          border-radius: 8px;
          font-size: 16px;
          color: #ff6600;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s ease;
        }
        .login-btn:hover { background: #ff6600; color: #fff; }

        .pricing-wrapper { text-align: center; padding: 40px 20px; }

        .toggle-container {
          display: flex; align-items: center; justify-content: center;
          gap: 15px; margin-bottom: 40px; font-size: 18px;
        }
        .toggle-container .active { font-weight: 700; color: #ff6600; }
        .save-text { color: #ff6600; font-weight: 500; }

        .switch { position: relative; width: 58px; height: 30px; }
        .switch input { display: none; }
        .slider {
          position: absolute; cursor: pointer;
          top: 0; left: 0; right: 0; bottom: 0;
          background-color: #ccc; transition: .4s;
          border-radius: 30px;
        }
        .slider:before {
          position: absolute; content: "";
          height: 24px; width: 24px;
          left: 3px; bottom: 3px;
          background: white; border-radius: 50%; transition: .4s;
        }
        input:checked + .slider { background-color: #ff6600; }
        input:checked + .slider:before { transform: translateX(28px); }

        .pricing-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 25px;
        }

        .pricing-card {
          background: #fff; padding: 25px;
          border-radius: 18px; border: 1px solid #eee;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          transition: transform .2s;
        }
        .pricing-card:hover { transform: translateY(-5px); }

        .pricing-card h3 { font-size: 22px; font-weight: 700; }
        .pricing-card h1 { margin: 15px 0; font-size: 35px; font-weight: 700; }
        .old-price { text-decoration: line-through; color: #888; }
        .desc { margin: 15px 0; color: #555; }

        .btn-subscribe {
          background: #ff6600; color: #fff;
          padding: 12px 25px; border-radius: 10px; border: none;
          cursor: pointer; font-weight: 600; width: 100%;
          transition: .3s;
        }
        .btn-subscribe:hover { background: #e65500; }

        @media (max-width: 600px) {
          .login-btn { padding: 6px 15px; font-size: 14px; }
        }
      `}</style>

      {/* HEADER */}
      <div className="pricing-header">
        <img src={Logo_small} className="small-logos" alt="logo" />
        <button className="login-btn" onClick={() => navigate("/signup")}>
          Signup
        </button>
      </div>

      <div className="pricing-wrapper">

        {/* TOGGLE */}
        <div className="toggle-container">
          <span className={!isYearly ? "active" : ""}>Monthly</span>
          <label className="switch">
            <input type="checkbox" checked={isYearly} onChange={() => setIsYearly(!isYearly)} />
            <span className="slider"></span>
          </label>
          <span className={isYearly ? "active" : ""}>Annual</span>

          {isYearly && <span className="save-text">Save upto 30%</span>}
        </div>

        {/* PRICING CARDS */}
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div className="pricing-card" key={index}>
              <h3>{plan.title}</h3>

              {/* INDIA = INR / OTHERS = USD */}
              {isIndianUser ? (
                <>
                  <h1>₹ {plan.price.toLocaleString()}</h1>
                  <p className="old-price">₹ {plan.old.toLocaleString()}/month</p>
                </>
              ) : (
                <>
                  <h1>$ {plan.price}</h1>
                  <p className="old-price">$ {plan.old}/month</p>
                </>
              )}

              <p className="desc">{plan.desc}</p>

              <button className="btn-subscribe" onClick={() => navigate("/signup")}>
                Subscribe Now
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
